
import { onMounted, useContext, useRoute } from '@nuxtjs/composition-api';
import useShoppingList from '@/composable/useShoppingList';
import useUtilities from '@/composable/useUtilities';
import useTlmCart from '@/composable/useTlmCart';
import { SHOPPING_LIST_ITEM_STATUS } from '@/constants/ShoppingListItemStatus';
import useCheckout from '@/composable/checkout/useCheckout';
import { CUSTOMER_TYPE } from '~/constants/CheckoutFlow';
import useOsm from '@/composable/checkout/validations/useOsm';
import useCheckoutInfo from '~/composable/useCheckoutInfo';
import useUserInQuarantine from '~/composable/checkout/validations/useUserInQurantine';

export default {
  props: {
    isReceipt: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const { app } = useContext()
    const { state } = useCheckout(app)
    const route = useRoute()
    const checkoutType = route.value.query.type
    const customerInfo = state?.customerInfo
    const { saveOsmDetails } = useOsm(app)
    const { getCustomerInfoInStorage } = useCheckoutInfo(app)
    const { isUserInQuarantine } = useUserInQuarantine(app)
    const {
      addressUpdated,
      numberOfUnProcessedItems,
      shoppingList,
      getFamilySubscriptionName,
      getDisplayPerMonthPrice,
      getClassForStatus,
      buyFamilySubscription,
      activeShoppingListItem,
      addAddressToCart,
      deleteShoppingList
    } = useShoppingList(app)
    const { getSubscriptionName } = useUtilities()
    const {
      isMobileBroadBandSubscription,
      isPayGSubscription,
      cart,
      cartHasHardware
    } = useTlmCart(app);

    const updateCustomerInfo = (updatedCart) => {
      const { firstName, lastName, streetName, streetNumber, additionalAddressInfo, apartment, postalCode, city } = updatedCart.billingAddress;
      // MIO-29627: never restore Erhvervskunde when cart has hardware
      const allowBusiness = checkoutType === CUSTOMER_TYPE.BUSINESS && !cartHasHardware.value

      if (!allowBusiness) {
        if (checkoutType === CUSTOMER_TYPE.PRIVATE) {
          customerInfo.privateInfo.name = `${firstName} ${lastName}`;
          customerInfo.privateInfo.street = streetName;
          customerInfo.privateInfo.houseNumber = streetNumber;
          customerInfo.privateInfo.floor = additionalAddressInfo;
          customerInfo.privateInfo.sideOrDoor = apartment;
          customerInfo.privateInfo.postalCode = postalCode;
          customerInfo.privateInfo.city = city;
          saveOsmDetails();
        }
        customerInfo.menu.value = CUSTOMER_TYPE.PRIVATE;
        return;
      }

      customerInfo.businessInfo.billingAddress = updatedCart.billingAddress;
      const { email, phone, cvr } = getCustomerInfoInStorage()
      customerInfo.businessInfo.cvr = cvr
      customerInfo.businessInfo.email = email
      customerInfo.businessInfo.emailValid = true
      customerInfo.businessInfo.cvrValid = true
      customerInfo.businessInfo.phone = phone
      saveOsmDetails();
      customerInfo.menu.value = CUSTOMER_TYPE.BUSINESS;
    };

    const handleShoppingListDeletion = () => {
      setTimeout(() => {
        const mismatch = !props.isReceipt && cart.value?.cartItemGroupList?.at(0)?.cartItems?.at(0)?.sku !== activeShoppingListItem.value?.sku
        if (props.isReceipt && numberOfUnProcessedItems.value === 0) {
          deleteShoppingList({ reset: !!mismatch })
        } else if (mismatch) {
          deleteShoppingList({ reset: true })
        }
      }, 300);
    };

    const initializeShoppingList = async () => {
      if (!props.isReceipt && numberOfUnProcessedItems.value !== shoppingList?.value?.shoppingListItem?.length) {
        const addressUpdateResponse = await addAddressToCart();
        if (addressUpdateResponse.actionStatus === 'OK') {
          const updatedCart = addressUpdateResponse.responseObject;
          updateCustomerInfo(updatedCart);
          addressUpdated.value = true
        } else {
          addressUpdated.value = false
        }
      }
    }

    handleShoppingListDeletion();

    onMounted(async () => {
      await initializeShoppingList();
    })

    return {
      isUserInQuarantine,
      numberOfUnProcessedItems,
      SHOPPING_LIST_ITEM_STATUS,
      activeShoppingListItem,
      buyFamilySubscription,
      getClassForStatus,
      getDisplayPerMonthPrice,
      getFamilySubscriptionName,
      isMobileBroadBandSubscription,
      isPayGSubscription,
      getSubscriptionName,
      shoppingList
    }
  }
}
